function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  fillRule: "evenodd",
  d: "M9.273 8l3.846-3.846.793-.793a.3.3 0 000-.424l-.848-.849a.301.301 0 00-.425 0L8 6.728l-4.64-4.64a.299.299 0 00-.423 0l-.85.848a.303.303 0 000 .425L6.728 8l-4.64 4.638a.303.303 0 000 .425l.85.848a.3.3 0 00.424 0L8 9.273l3.845 3.846.793.793a.301.301 0 00.425 0l.848-.848a.301.301 0 000-.425L9.273 8z"
});

function SvgContractCloseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgContractCloseinline;